import ServiceLogMatrix from './service-log-matrix';
import Ubo4Download from './UBO4';
import CensusDownload from './census';
import MdsDownload from './mds';
import { useFeatureToggleWhenReady } from 'src/hooks/use-feature-toggle';
import {
  reportsDownloadUB04,
  reportsDownloadCensusDetails,
  reportsDownloadMDSAssessmentDetails,
} from 'src/config';

function useDownloadData() {
  const [isUB04Enabled] = useFeatureToggleWhenReady(reportsDownloadUB04, 'ENTERPRISE');
  const [isCensusDetailsEnabled] = useFeatureToggleWhenReady(
    reportsDownloadCensusDetails,
    'ENTERPRISE'
  );
  const [isMDSAssessmentDetailsEnabled] = useFeatureToggleWhenReady(
    reportsDownloadMDSAssessmentDetails,
    'ENTERPRISE'
  );

  const downloadData = [
    {
      title: 'Service Log Matrix Report',
      description: {},
      children: <ServiceLogMatrix />,
    },
    {
      ...(isUB04Enabled
        ? {
            title: 'UB04 Report',
            description: {},
            children: <Ubo4Download />,
          }
        : {}),
    },
    {
      ...(isCensusDetailsEnabled
        ? {
            title: 'Census Details',
            description: {
              Includes:
                'Patient payer, admit date, start of care, & end of care; & counts by payer & discipline.',
            },
            children: <CensusDownload />,
          }
        : {}),
    },
    {
      ...(isMDSAssessmentDetailsEnabled
        ? {
            title: 'MDS Assessment Details',
            description: {
              Includes: 'ICD codes, Section O, & Section GG',
            },
            children: <MdsDownload />,
          }
        : {}),
    },
  ];

  return {
    downloadData,
  };
}

export default useDownloadData;
